import { Col, Divider, Row } from 'antd';
import { PurchaseDefaultEntity } from 'domain/entities/PurchaseEntity';
import moment from 'moment';
import { COMMON } from 'utilities/constants/COMMON';
import { DATE_FORMAT } from 'utilities/constants/DATE';
import { commonHelpers } from 'utilities/helpers';

interface props {
    userInfo?: PurchaseDefaultEntity;
}

export const UserInfo = ({ userInfo }: props) => {
    return (
        <div className="w-full mb-[48px]">
            <span className="content-step-form heading-step-form">基本情報</span>
            <Divider className="mb-6 my-1" />

            <Row className="mb-6">
                <Col span={12} className="pr-[12px]">
                    <span className="content-step-form label-step-form">氏名</span>
                    <span className="content-step-form">
                        {userInfo?.memberName ?? COMMON.EMPTY}
                    </span>
                </Col>
                <Col span={12} className="pl-[12px]">
                    <span className="content-step-form label-step-form">氏名（カナ）</span>
                    <span className="content-step-form">
                        {userInfo?.memberNameKana ?? COMMON.EMPTY}
                    </span>
                </Col>
            </Row>
            <Row>
                <Col span={12} className="pr-[12px]">
                    <span className="content-step-form label-step-form">生年月日</span>
                    <span className="content-step-form">
                        {userInfo?.birthday && moment(userInfo?.birthday, true).isValid()
                            ? moment(userInfo?.birthday).format(DATE_FORMAT.FORMAT4)
                            : COMMON.EMPTY}
                    </span>
                </Col>
                <Col span={12} className="pl-[12px]">
                    <span className="content-step-form label-step-form">満年齢</span>
                    <span className="content-step-form">
                        {commonHelpers.calculateAge(userInfo?.birthday)}歳
                    </span>
                </Col>
            </Row>
        </div>
    );
};
